// @ts-check
import React from 'react';
import {
  HorizontalMenuIcon,
  MicOffIcon,
  VideoOffIcon,
  VideoOnIcon,
  MicOnIcon,
  SpeakerIcon,
  RemoveUserIcon,
} from '@100mslive/react-icons';
import {
  useHMSStore,
  selectPermissions,
  useHMSActions,
  useRemoteAVToggle,
} from '@100mslive/react-sdk';
import {Flex, StyledMenuTile, Slider} from '@100mslive/roomkit-react';
import '../../App.css'
/**
 * Taking peerID as peer won't necesarilly have tracks
 */
const TileMenu = ({
  audioTrackID,
  videoTrackID,
  peerID,
  isScreenshare = false,
}: any) => {
  const actions = useHMSActions();
  let {removeOthers}: any = useHMSStore(selectPermissions);
  removeOthers = removeOthers && !isScreenshare;
  const {
    isAudioEnabled,
    isVideoEnabled,
    setVolume,
    toggleAudio,
    toggleVideo,
    volume,
  } = useRemoteAVToggle(audioTrackID, videoTrackID);
  if (!(removeOthers || toggleAudio || toggleVideo || setVolume)) {
    return null;
  }
  return (
    <StyledMenuTile.Root>
      <StyledMenuTile.Trigger data-testid="participant_menu_btn">
        <HorizontalMenuIcon />
      </StyledMenuTile.Trigger>
      <StyledMenuTile.Content style={{ backgroundColor: 'white'}} side="left" align="start" sideOffset={10}>
        {toggleVideo ? (
          <>
            <button
              className='App-font'
              style={{padding: 8, border: 'none', backgroundColor: 'white' }}
              onClick={toggleVideo}
              data-testid={
                isVideoEnabled
                  ? 'mute_video_participant_btn'
                  : 'unmute_video_participant_btn'
              }
            >
              <Flex align="center" gap={1}>
                {isVideoEnabled ? <VideoOnIcon /> : <VideoOffIcon />}
                <span style={{fontSize: 14}}>{`${isVideoEnabled ? 'Mute' : 'Request Unmute'}`}</span>
              </Flex>
            </button>
            <div style={{ backgroundColor: 'gray', height: 1 }}></div>
          </>
        ) : null}
        {toggleAudio ? (
          <>
            <button
              className='App-font'
              style={{ padding: 8, border: 'none', backgroundColor: 'white' }}
              onClick={toggleAudio}
              data-testid={
                isVideoEnabled
                  ? 'mute_audio_participant_btn'
                  : 'unmute_audio_participant_btn'
              }
            >
              <Flex align="center" gap={1}>
                {isAudioEnabled ? <MicOnIcon /> : <MicOffIcon />}
                <span style={{fontSize: 14}}>{`${isAudioEnabled ? 'Mute' : 'Request Unmute'}`}</span>
              </Flex>
            </button>
            <div style={{ backgroundColor: 'gray', height: 1 }}></div>
          </>
        ) : null}
        {audioTrackID ? (
          <>
            <button
              className='App-font'
              style={{ padding: 8, border: 'none', backgroundColor: 'white' }}
              data-testid="participant_volume_slider">
              <Flex align="center" gap={1}>
                <SpeakerIcon /> <span style={{fontSize: 14}}>Volume</span>
              </Flex>
              <Slider
                css={{ my: '0.5rem', width: '95%' }}
                step={5}
                value={[volume || 0]}
                onValueChange={(e: any) => {
                  if (setVolume) {
                    setVolume(e[0]);
                  }
                }}
              />
            </button>
            {removeOthers &&
            <div style={{ backgroundColor: 'gray', height: 1 }}></div>
            }
          </>
        ) : null}

        {removeOthers ? (
          <button
            className='App-font'
            style={{ padding: 8, border: 'none', backgroundColor: 'white' }}
            onClick={async () => {
              try {
                await actions.removePeer(peerID, '');
              } catch (error) {
                // TODO: Toast here
              }
            }}
            data-testid="remove_participant_btn"
          >
            <Flex align="center" gap={1}>
              <RemoveUserIcon />
              <span style={{fontSize: 14}}>Remove Participant</span>
            </Flex>
          </button>
        ) : null}
      </StyledMenuTile.Content>
    </StyledMenuTile.Root>
  );
};

export default TileMenu;
